import type { FilterRecipe } from "../../../components/GenericTable/SubComponents/TableHeader/ListHeader";

// Free-text "Color" filter in the logo list's filter row (flag
// REACT_APP_LOGO_COLOR_FILTER_ENABLED): type a colour code such as 877c and
// get every logo that carries that colour. Pure module - the view model
// passes the flag in, so the recipe (and the field it renders) exists only
// with the flag on; off, the filter row is today's. The typed value rides
// on the list's ONE existing request as filterByField=color&filterByValue=
// <text> (see TextFilter.tsx for when it is sent); the API matches it
// against the logos' colour codes behind its own flag
// LogoListColorFilterEnabled - API first. Several colours go in the same
// field separated by a comma (or semicolon), "white, 877": the text is sent
// as it is, in the one value, and the API reads it as logos that carry ALL
// of them (up to 5). The field's tooltip (logoList.colorHint) says so.
export const LOGO_COLOR_FILTER_KEY = "color";

export function buildLogoColorFilterRecipe(
  enabled: boolean,
  t: (key: string) => string,
): FilterRecipe<string> | undefined {
  if (!enabled) return undefined;
  return {
    key: LOGO_COLOR_FILTER_KEY,
    options: [],
    getOptionValue: (option) => option,
    defaultTitle: t("logoList.color"),
    text: true,
    hint: t("logoList.colorHint"),
  };
}
